module.exports = __webpack_public_path__ + "static/media/mechanical keyboard.4cde2950.jpeg";